import { useSelector } from 'react-redux';
import * as BuyIntentionSelectors from 'store/state/buyIntention/buyIntenteionSelectors';
import BuyIntentionItems from '../List/BuyIntentionItems';

export default function Step01AssembleOrder() {
  const tableData = useSelector(BuyIntentionSelectors.getBuyIntentionEdit);
  return (
    <div key="0">
      <BuyIntentionItems tableData={tableData} />
    </div>
  );
}
